import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TooltipPosition, TooltipTheme } from './tooltip.enums';

@Component({
  selector: 'rkt-tooltip-component',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class TooltipComponent {
  position: TooltipPosition = 'above';
  theme: TooltipTheme = 'dark';
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;
}
